import type { FraudStatus } from '../dataProvider/types';

/** Display helpers for the Fraud queue. */

export const FRAUD_STATUS_LABEL: Record<FraudStatus, string> = {
  active: 'Active',
  suspended: 'Suspended',
  banned: 'Banned',
};

/** Chip colour per fraud status: active neutral, suspended a warning, banned an
 *  error (terminal). */
export const FRAUD_STATUS_COLOR: Record<
  FraudStatus,
  'default' | 'warning' | 'error'
> = {
  active: 'default',
  suspended: 'warning',
  banned: 'error',
};

/** "82 / 100" — the risk score against the scale, shown as a fact, never recomputed. */
export const formatRisk = (score: number): string => `${score} / 100`;
